<template>
    <section class="relative">
        <div class="max-w-md mx-auto mt-8 px-4">
            <label for="location" class="block text-sm leading-5 font-medium text-brand-gray-700 mb-4">Where are you located?
            </label>
            <select id="location"
                    v-model="selected_state"
                    @change="findRD()"
                    class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-brand-gray-300 focus:outline-none focus:ring-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                <option value="">Select Your State / Province</option>
                <optgroup label="US States">
                    <option :value="state.abbreviation" v-for="state in states">{{ state.province }}</option>
                </optgroup>
                <optgroup label="Canadian Provinces">
                    <option :value="province.abbreviation" v-for="province in provinces">{{ province.province }}</option>
                </optgroup>
            </select>
        </div>
        <transition-group class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mx-auto my-12 px-4" name="contacts">
            <div v-for="contact in filteredContacts" :key="contact.name" :class="`contact bg-white rounded-lg flex flex-col items-center p-4 ${getAbbrStr(contact)}`">
                <img :src="contact.photo_url"
                     class="w-24 rounded-full"
                     :alt="contact.name">
                <div class="my-6 w-full">
                    <h4 class="text-center text-2xl font-bold leading-none">{{contact.name}}</h4>
                    <h5 class="text-center text-lg leading-none font-bold">
                        <span v-if="contact.credentials !== ''"><small>{{contact.credentials}}</small></span><span v-else>&nbsp;</span>
                    </h5>
                    <h5 class="mt-4 text-center font-semibold leading-tight">{{contact.title}}</h5>
                    <p class="text-center leading-snug my-2"><a class="text-blue-700" :href="'mailto:'+contact.email">{{contact.email}}</a></p>
                    <p class="text-center leading-snug my-2"><a class="text-blue-700" :href="'tel:'+contact.phone">{{contact.phone}}</a></p>
                    <p v-if="contact.calendly_url" class="text-center leading-snug my-2"><a class="text-blue-700" :href="contact.calendly_url" target="_blank">Book An Appointment</a></p>
                    <ul class="border border-brand-gray-300 mt-5 w-full">
                        <li v-for="state in contact.us_territory"
                            :class="`py-3 text-center border-b border-brand-gray-300 ${selected_state===state.abbreviation ? 'bg-brand-gray-600 text-brand-gray-300' : ''}`" >
                            {{state.province}}
                        </li>
                        <li v-if="contact.ca_territory.length > 0"
                            :class="`py-3 text-center border-b border-brand-gray-300 ${contact.ca_territory.filter((el) => el.abbreviation===selected_state).length > 0?'bg-brand-gray-600 text-brand-gray-300' : ''}`">
                            Canada
                        </li>
                    </ul>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import axios from 'axios';

export default {
        name: "r-d-contact-list",

        data() {
            return {
                contacts: [],
                provinces: [],
                selected_state: '',
                states: []
            };
        },

        computed: {
            filteredContacts() {
                return this.selected_state === '' ? this.contacts : this.contacts.filter((contact) => {
                    const allProvinces = [...contact.ca_territory, ...contact.us_territory];
                    if (allProvinces.length === 0 && (this.selected_state === 'AA' || this.selected_state === 'AE' || this.selected_state === 'AP')) {
                        return true;
                    }
                    const matchingProvinces = allProvinces.filter((prov) => prov.abbreviation === this.selected_state);
                    return matchingProvinces.length > 0;
                });
            }
        },

        mounted() {
            axios.get('/ajax/regional-directors').then(({data}) => {
                this.contacts = data;
            });
            axios.get('/ajax/countries/US').then(({data}) => {
                this.states = data;
            });
            axios.get('/ajax/countries/CA').then(({data}) => {
                this.provinces = data;
            });
        },



        methods: {
            getAbbrStr(contact) {
                if (contact.us_territory.length === 0 && contact.ca_territory.length === 0 ) {
                    return 'AA AE AP';
                }
                let array = [...contact.us_territory, ...contact.ca_territory];
                return array.map((el) => {
                    return el.abbreviation;
                }).join(' ');
            },

            findRD() {
                const currentActive = document.querySelector('.active');
                if (currentActive !== null) {
                    currentActive.classList.remove('active');
                    document.querySelectorAll('.inactive').forEach((el) => {
                        el.classList.remove('inactive');
                    });
                }
                if(this.selected_state !== '') {
                    const selectedEl = document.querySelector('.'+this.selected_state);
                    if (selectedEl !== null) {
                        selectedEl.classList.remove('inactive');
                        selectedEl.classList.add('active');
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .contact {
        transition: all .35s ease-in-out;
    }
    .contacts-enter {
        transform: scale(0.5) translatey(-80px);
        opacity:0;
    }

    .contacts-leave-to{
        transform: translatey(30px);
        opacity:0;
    }

    .contacts-leave-active {
        position: absolute;
        z-index:-1;
    }
</style>